import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Segment,
  Table,
  Grid,
  Header,
  Icon,
  Button,
  Input,
  Message,
  Label,
  Modal,
  Menu,
  Popup,
  Loader
} from 'semantic-ui-react'
import { periodDbField } from '../../utils/gradingScheme'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'
import constantCase from 'constant-case'

import './ClassConducts.css'
import ClassConductsApproval from './ClassConductsApproval'

const _ = { find, groupBy, orderBy }

const changeCase = {
  constantCase: constantCase
}

// Was a second copy of the PC's four-quarter map. The column comes from the
// scheme now, so a three-term year cannot resolve a fourth period.

const ClassConductsPV = (props) => {
  if (props.auth) {
    const {
      column, direction, section, error, success, username, dirtyInput, quarter, userId, userType,
      sectionStudents, areClassConductsSaved, sectionStudentId, subjectConducts, sectionSubjects
    } = props;

    if(section.length !== 1) return <Loader active inline='centered' />;

    const sectionDetail = _.find(section[0].details, {
      type: 'conduct',
      quarter: parseInt(quarter)
    });

    let isDisabled = true;

    if(sectionDetail.status === 'To Do' || sectionDetail.status === 'Discarded') {
      if(userType === 'admin' || section[0].teacherId === userId) {
        isDisabled = false;
      }
    } else if(sectionDetail.status === 'Created') {
      if(userType === 'admin' || userType === 'levelHead') {
        isDisabled = false;
      }
    } else {
      if(userType === 'admin' || userType === 'principal' || userType === 'registrar') {
        isDisabled = false;
      }
    }

    const gender = _.groupBy(sectionStudents, o => o.student.gender)
    let currentDataMale = [], currentDataFemale = [];
    if(gender.hasOwnProperty('Male')) {
      currentDataMale = gender['Male'];
    }

    if(gender.hasOwnProperty('Female')) {
      currentDataFemale = gender['Female'];
    }

    const studentsTableMale = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      if (props[`${changeCase.constantCase(studentName)}`] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-1`]} </span> :
                  <Input
                    name={`${changeCase.constantCase(studentName)}-1`}
                    size='small'
                    className='class-conducts-input'
                    value={props[`${changeCase.constantCase(studentName)}-1`]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-2`]} </span> :
                  <Input
                    name={`${changeCase.constantCase(studentName)}-2`}
                    size='small'
                    className='class-conducts-input'
                    value={props[`${changeCase.constantCase(studentName)}-2`]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-3`]} </span> :
                  <Input
                    name={`${changeCase.constantCase(studentName)}-3`}
                    size='small'
                    className='class-conducts-input'
                    value={props[`${changeCase.constantCase(studentName)}-3`]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span>
                {props[`${changeCase.constantCase(studentName)}`]}
              </span>
            </Table.Cell>
            <Table.Cell
              textAlign='center'
              className='class-conduct-table-cell-clickable'
              collapsing
              onClick={() => props.handleOpen(sectionStudent.sectionStudentId)}
            >
              <span>
                {props[`${changeCase.constantCase(studentName)}-S`]}
              </span>
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span>
                {props[`${changeCase.constantCase(studentName)}-FG`]}
              </span>
            </Table.Cell>

          </Table.Row>
        );
      }
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
      if (props[`${changeCase.constantCase(studentName)}`] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-1`]} </span> :
                  <Input
                    name={`${changeCase.constantCase(studentName)}-1`}
                    size='small'
                    className='class-conducts-input'
                    value={props[`${changeCase.constantCase(studentName)}-1`]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-2`]} </span> :
                  <Input
                    name={`${changeCase.constantCase(studentName)}-2`}
                    size='small'
                    className='class-conducts-input'
                    value={props[`${changeCase.constantCase(studentName)}-2`]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-3`]} </span> :
                  <Input
                    name={`${changeCase.constantCase(studentName)}-3`}
                    size='small'
                    className='class-conducts-input'
                    value={props[`${changeCase.constantCase(studentName)}-3`]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span>
                {props[`${changeCase.constantCase(studentName)}`]}
              </span>
            </Table.Cell>
            <Table.Cell
              textAlign='center'
              className='class-conduct-table-cell-clickable'
              collapsing
              onClick={() => props.handleOpen(sectionStudent.sectionStudentId)}
            >
              <span>
                {props[`${changeCase.constantCase(studentName)}-S`]}
              </span>
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span>
                {props[`${changeCase.constantCase(studentName)}-FG`]}
              </span>
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>1</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>2</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>3</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>ADV</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>SUB</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>FG</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )

    let totalGrades = 0;
    const tableBody = subjectConducts.map((subjectConduct, key) => {
      if (sectionStudentId !== '') {
        const subject = _.find(sectionSubjects, {
          sectionSubjectId: subjectConduct.sectionSubjectId
        });
        const conductHasSubject = _.find(sectionSubjects, (sectionSubject) => {
          if (sectionSubject.sectionSubjectId === subjectConduct.sectionSubjectId) {
            return true
          } else {
            return false;
          }
        });
        if (subjectConduct.sectionStudentId === sectionStudentId && conductHasSubject) {
          // Four near-identical branches collapsed to one lookup. They also
          // compared the URL's quarter with === against '1'..'4', so a numeric
          // quarter matched nothing and the row rendered blank.
          const conductField = periodDbField(
            quarter, props.scheme ? props.scheme.periods.length : undefined);
          if (conductField) {
            totalGrades = totalGrades + subjectConduct[conductField];
            if (subject) {
              return (
                <Table.Row key={key} className='sections-table-row'>
                  <Table.Cell>{subject.subject.name}</Table.Cell>
                  <Table.Cell textAlign='right'>{subjectConduct[conductField]}</Table.Cell>
                </Table.Row>
              );
            } else {
              return null
            }
          }  else {
            totalGrades = 0;
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    })
    const sortedCreated = _.orderBy(props.created, ['createdDate'], ['asc']);
    const createdTableBody = sortedCreated.map((create, key )=> {
      const section = _.find(props.sections, {
        sectionId: create.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/classconducts/${create.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedChecked = _.orderBy(props.checked, ['checkedDate'], ['asc']);
    const checkedTableBody = sortedChecked.map((check, key )=> {
      const section = _.find(props.sections, {
        sectionId: check.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/classconducts/${check.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedReviewed = _.orderBy(props.reviewed, ['createdDate'], ['asc']);
    const reviewedTableBody = sortedReviewed.map((review, key )=> {
      const section = _.find(props.sections, {
        sectionId: review.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/classconducts/${review.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });

    return (
      <div>
        <Segment>
          {
            sectionStudents.length === 0 ?
            <Segment placeholder>
              <Header icon>
                <Icon name='database' />
                Populate the {section[0].gradeLevel} - {section[0].name} with students.
              </Header>
              <Button primary>Section Page</Button>
            </Segment> :
            <Grid>
              <Grid.Row className="class-conduct-title-row" columns={3}>
                <Grid.Column width={8}>
                  <span className="class-conduct-title">
                    {section[0].gradeLevel} - {section[0].name}
                  </span>
                </Grid.Column>
                <Grid.Column width={3}>
                </Grid.Column>
                <Grid.Column width={5} textAlign='right'>

                {
                  sectionDetail.status === 'Approved' ?
                  <Label color='green' horizontal>
                    {sectionDetail.status}
                  </Label> :
                  <Label color='yellow' horizontal>
                    {sectionDetail.status}
                  </Label>
                }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Menu compact>
                      {
                        userType === 'admin' ||  userType === 'levelHead'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='check' /> For Checking
                              <Label color={props.created.length === 0 ? 'green' : 'red'} floating>
                                {props.created.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.created.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {createdTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                      {
                        userType === 'admin' ||  userType === 'registrar'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='book' /> For Review
                              <Label color={props.checked.length === 0 ? 'green' : 'red'} floating>
                                {props.checked.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.checked.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {checkedTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                      {
                        userType === 'admin' ||  userType === 'principal'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='thumbs up' /> For Approval
                              <Label color={props.reviewed.length === 0 ? 'green' : 'red'} floating>
                                {props.reviewed.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.reviewed.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {reviewedTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                    </Menu>
                </Grid.Column>
                <Grid.Column width={8} textAlign='right'>
                  {
                    areClassConductsSaved &&
                    <ClassConductsApproval
                      username={username}
                      userType={userType}
                      sectionDetail={sectionDetail}
                      open={props.open}
                      handleApprovalOpen={props.handleApprovalOpen}
                      handleApprovalClose={props.handleApprovalClose}
                      handleUpdateSectionDetails={props.handleUpdateSectionDetails}
                    />
                  }
                  <Button floated='right' onClick={props.handleSubmit} color='green' icon labelPosition='left'>
                    <Icon name='save' /> Save Conduct Sheet
                  </Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4}>
                  <span>
                    <strong>1</strong> - <em>Behavior </em> (5 pts)<br/>
                    <strong>2</strong> - <em>Responsibility and Showing Concern for Others</em> (5 pts)<br/>
                    <strong>3</strong> - <em>Punctuality / Regularity</em> (5 pts)<br/>
                  </span>
                </Grid.Column>
                <Grid.Column width={4}>
                  <span>
                    <strong>ADV</strong> - <em>Class Adviser Total</em> <br/>
                    <strong>SUB</strong> - <em>Average of Subjects Total</em> <br/>
                    <strong>FG</strong> - <em>Final Grade (Base 60)</em> <br/>
                  </span>
                </Grid.Column>
              </Grid.Row>
              {
                dirtyInput ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header='Some changes were made.'
                      content="It might be your changes or from the subject teacher's conduct grades. Please save."
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                error ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      error
                      header='Class Conduct Error'
                      content='Conducts must be between 70 and 100.'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                success ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      positive
                      header='Conduct successfully saved!'
                      content='Good job!'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                sectionDetail.status === 'Discarded' ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header={`Your submission was discarded by ${sectionDetail.discardBy}`}
                      content={sectionDetail.discardNotes}
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              <Grid.Row>
                <Grid.Column width={8}>
                  <h4>Male</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableMale}</Table.Body>

                  </Table>
                </Grid.Column>

                <Grid.Column width={8}>
                  <h4>Female</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableFemale}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>

            </Grid>
          }

        </Segment>

        <Modal
          open={props.modalOpen}
          onClose={props.handleClose}
          size='small'
        >
          <Header content='Conduct Subjects' />
          <Modal.Content>
            {
              subjectConducts.length === 0 ?
              <Loader active className='workaround' inline='centered'/> :
              <Table stackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Subject</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>Conduct Grade</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {tableBody}
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell>{sectionSubjects.length} Subject/s</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>TOTAL: {totalGrades}</Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button color='green' onClick={props.handleClose} inverted>
              <Icon name='checkmark' /> Okay
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  } else {
    return <Redirect to='/' />
  }

}

export default ClassConductsPV;
